export var TABLE_EXPANDABLE_SECTION_CLASS_PREFIX = 'TableExpandableSection';
export var RESIZE_OBSERVER_SUPPORTED = !!global.ResizeObserver;